import React from 'react';
import { Trans } from '@lingui/react';

export const content = Object.freeze({
  orderCompleted: <Trans>Order Completed</Trans>,
  thankYou: <Trans>Thank you for your order</Trans>,
  buttonText: <Trans>Go back to home</Trans>,
  emailText: <Trans>Email with transaction information has been sent to your inbox</Trans>,
});
